import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Spinner } from "react-bootstrap";
import { FiLock } from "react-icons/fi";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import api from "../../../utils/helper";

const PhoneModal = () => {
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const navigate = useNavigate();
   const location = useLocation();

  const countryList = [
    { code: "+91", name: "India" },
    { code: "+92", name: "United States" },
    { code: "+93", name: "United Kingdom" },
    { code: "+94", name: "Australia" },
    { code: "+95", name: "China" },
    { code: "+96", name: "Japan" },
    // Add more countries as needed
  ];

  const handleGetOTP = () => {
    // Handle OTP logic 
    sendOTPMutation.mutate(location.state)
  };

  const sendOTPMutation = useMutation({
    mutationFn: (credentials) =>
      api.post("/auth/send-otp", credentials, "vendor"),
    onSuccess: () => {
      navigate("/vendor/otp-verification", { state: location.state });
    },

  });

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center vh-100"
    >
      <Card className="phone-modal">
        <Card.Body className="phone-modal__body">
          {/* Lock Icon */}
          <div className="text-center mb-3">
            <div className="phone-modal__icon-wrapper">
              <FiLock className="phone-modal__lock-icon" />
            </div>
          </div>

          {/* Title */}
          <h6 className="phone-modal__title">Add your phone number</h6>

          {/* Subtitle */}
          <p className="phone-modal__subtitle">
            Link your phone to secure your account
          </p>

          {/* Phone Input */}
          <Form>
            <Form.Group className="mb-4">
              <Form.Label className="phone-modal__form-label">
               Enter your phone
              </Form.Label>

              <div className="input-group">
                <Form.Select
                  className="phone-modal__country-select"
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                >
                  {countryList.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.code}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control type="tel" className="phone-modal__phone-input" />
              </div>
            </Form.Group>

              {sendOTPMutation?.error && (
              <p className="text-danger family-inter">
                {sendOTPMutation?.error?.response?.data?.message ||
                  "Error while sending OTP!"}
              </p>
            )}

           <div className="phone-modal__button-container">
              <Button variant="light" className="phone-modal__button">
                Cancel
              </Button>
              <Button
                variant="primary"
                className="phone-modal__button phone-modal__button--primary"
                onClick={handleGetOTP}

                disabled={sendOTPMutation.isLoading}
              >
                {sendOTPMutation.isLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Sending...
                  </>
                ) : (
                  "Send OTP"
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PhoneModal;
